var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_msg_area"},[_c('div',{staticClass:"err_header"},[_vm._v("404. "+_vm._s(_vm.$T('common.err.404.title')))]),_vm._v(" "),_c('div',{staticClass:"err_msg"},[_vm._v("\n    "+_vm._s(_vm.$T('common.err.404.msg', { url: _vm.getUrl() }))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }